import { crudActions, crudMutations, crudGetters } from "@/utils/store";
import isEmpty from "lodash/isEmpty"

const BASE_URL = `${process.env.BASE_URL_V2}/admin/categories/`
const BASE_URL_V2 = process.env.BASE_URL_V2

export const state = () => ({
  objects: [],
  total: 0,
  navTree: [],
  navTreeDetail: []
})

export const mutations = {
  ...crudMutations,
  setNavTree(state, payload) {
    state.navTree = payload
  },
  setNavTreeDetail(state, payload) {
    state.navTreeDetail = payload
  },
}

export const actions = {
  ...crudActions(BASE_URL),
  async tree({ commit }, params = {}) {
    const urls = BASE_URL_V2
      ? [`${BASE_URL_V2}/public/object_categories/tree/`, `/public/object_categories/tree/`]
      : [`/public/object_categories/tree/`]

    for (const url of urls) {
      try {
        return await this.$axios.$get(url, { params })
      } catch (e) {
        // try next base URL
      }
    }
    return []
  },
  async treeDetail({ commit }, params = {}) {
    return this.$axios.$get(`${BASE_URL_V2}/public/object_categories/tree/`, { params: params })
  },
  async getNavTree({ state, commit, dispatch }) {
    if (isEmpty(state.navTree)) {
      commit('setNavTree', await dispatch('tree'))
      return state.navTree
    } else {
      return state.navTree
    }
  },
  async fetchObject({}, id) {
    const urls = BASE_URL_V2
      ? [`${BASE_URL_V2}/public/object_categories/${id}/`, `/public/object_categories/${id}/`]
      : [`/public/object_categories/${id}/`]

    for (const url of urls) {
      try {
        return await this.$axios.$get(url)
      } catch (e) {
        // try next base URL
      }
    }
    throw new Error('Category not found')
  },
  async fetchObjects({ commit }, params = {}) {
    const response = await this.$axios.$get('/public/object_categories/', { params: params })
    commit('SET_OBJECTS', { objects: response['items'], total: response['total'] })
    return response
  },
  async publicTree({ commit }, params = {}) {
    return this.$axios.$get(`/public/object_categories/tree/`, { params: params })
  },
  async getNavTreeDetail({ state, commit, dispatch }) {

    if (isEmpty(state.navTreeDetail)) {
      commit('setNavTreeDetail', await dispatch('treeDetail'))
      return state.navTreeDetail
    } else {
      return state.navTreeDetail
    }


  },
  async uploadCategoryFile({}, { id, field, file }) {
    const formData = new FormData()
    formData.append('file', file)

    return this.$axios.$post(
      `/admin/object_categories_files/${id}/${field}/?content_type=${encodeURIComponent(file.type)}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },
  async deleteCategoryFile({}, { id, field }) {
    return this.$axios.$delete(`/admin/object_categories_files/${id}/${field}/`)
  },
}

export const getters = {
  ...crudGetters,
  navTree: (state) => {
    return state.navTree
  },
  navTreeDetail: (state) => {
    return state.navTreeDetail
  },
}
